import { useTracking } from '@components/hooks';
import { useEffect, useRef } from 'react';

// Custom hook to handle tracking logic
export const useTrackModalClick = ({ open, title, productOption, voucher }) => {
  const track = useTracking();
  const initialRender = useRef(true);
  const { key, bindung, mixtype, capprice } = productOption || {};

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      track({
        event: 'modal-click',
        interaction: open ? 'click-tarif-auswaehlen' : 'click-modal-schließen',
        tarifId: key,
        tarifName: title,
        tarifCommitment: bindung === 'year' ? 12 : 0,
        tarifSourceType: mixtype,
        tarifCap: capprice === 'yes',
        voucher,
      });
    }
  }, [open, title, productOption, voucher, track]);
};
